import { render, staticRenderFns } from "./DoPage.vue?vue&type=template&id=23f85bbb&scoped=true"
import script from "./DoPage.vue?vue&type=script&lang=js"
export * from "./DoPage.vue?vue&type=script&lang=js"
import style0 from "./DoPage.vue?vue&type=style&index=0&id=23f85bbb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f85bbb",
  null
  
)

export default component.exports